import type {
  InteractiveContent,
  ScaleResult,
} from '@core-api/presentation/types/response';
import type { ScalesResultForVisualization } from '../types';

export const transformScalesForVisualization = (
  scalesResults: ScaleResult[],
  choices: InteractiveContent['choices'],
): ScalesResultForVisualization[] => {
  return choices.map((choice) => {
    const result = scalesResults.find(
      (res) =>
        res.interactiveContentChoiceId === choice.interactiveContentChoiceId,
    );

    if (!result) {
      return {
        id: choice.interactiveContentChoiceId ?? '',
        label: choice?.title ?? '',
        score: {},
        skips: 0,
        identifiedResults: [],
      };
    }

    const score = result.scaleResults.reduce<Record<number, number>>(
      (acc, scaleResult) => {
        acc[scaleResult.value] = scaleResult.responseCount;
        return acc;
      },
      {},
    );

    return {
      id: result.interactiveContentChoiceId ?? '',
      label: choice?.title ?? '',
      score,
      skips: result.skips,
      identifiedResults: result.scaleResults,
    };
  });
};
